import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from '../fmeda/services/api.service';
import { Project } from '../fmeda/models';
import { StoreService } from '../fmeda/services/store.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap/tooltip';

@Component({
    selector: 'app-fmeda-landing',
    templateUrl: './fmeda-landing.component.html',
    styleUrls: ['./fmeda-landing.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, AsyncPipe, DatePipe, NgbTooltipModule]
})
export class FmedaLandingComponent implements OnInit {
    projects: Project[] = [];
    hasApiError = false;
    apiError = '';
    projectTileLimit = 6;

    constructor(
        public auth: AuthService,
        private api: ApiService,
        private store: StoreService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.auth.isAuthenticated$.subscribe((res) => {
            if (res) {
                this.getProjects();
            }
        });
    }

    getProjects() {
        this.api.getProjects().subscribe({
            next: (res) => {
                this.hasApiError = false;
                const projects = res.data || [];
                this.projects = [...projects]
                    .sort((a, b) => {
                        const da = this.createdAtMs(a.created_at);
                        const db = this.createdAtMs(b.created_at);
                        if (db !== da) {
                            return db - da;
                        }
                        return a.id.localeCompare(b.id);
                    })
                    .slice(0, this.projectTileLimit);
            },
            error: (error) => {
                this.hasApiError = true;
                this.apiError = error.error?.message || error.message;
            },
        });
    }

    private createdAtMs(createdAt?: string | null): number {
        if (!createdAt) {
            return 0;
        }
        const ms = Date.parse(createdAt);
        return Number.isNaN(ms) ? 0 : ms;
    }

    getRiskLevel(projectId: string): 'low' | 'medium' | 'high' {
        // Use a stronger deterministic hash so typical IDs do not collapse
        // into the same bucket.
        let hash = 5381;
        for (let i = 0; i < projectId.length; i += 1) {
            hash = ((hash << 5) + hash) ^ projectId.charCodeAt(i);
        }
        const level = Math.abs(hash) % 3;
        return level === 0 ? 'low' : level === 1 ? 'medium' : 'high';
    }

    getRiskColor(riskLevel: 'low' | 'medium' | 'high'): string {
        switch (riskLevel) {
            case 'low':
                return '#4CAF50'; // Green
            case 'medium':
                return '#FFC107'; // Amber
            case 'high':
                return '#F44336'; // Red
        }
    }

    openProject(project: Project) {
        this.store.setCurrentProject({ id: project.id, name: project.name });
        this.router.navigateByUrl('/fmeda-workspace');
    }
}
